import React from 'react'
import { ImageMedia, MotionContent } from '../../components/imports';
import ThisProject from '../ThisProject';

const Content = () => {

  return (
    <ThisProject>
      {({ thisProject, projectId, prLink }) => (

        <>
          <div className=' w-full block pt-12'>
            <div className='flex flex-col w-full items-center justify-center *:w-full resp relative px-0 rounded-lg overflow-clip *:mix-blend-screen'>
              <ImageMedia src={require(`./assets/amossa_A2.jpg`)} className="w-full object-cover z-[1]" />
              <ImageMedia src={require(`./assets/amossa_A.jpg`)} className="w-full object-cover translate-y-[-20%]" />
            </div>
          </div>


          <div className='flex w-full bg-black'>
            <div className='flexResp resp w-full startAll maxW resp mt-12'>
              <div className='flex flex-col w-full flex-[.6]'>
                <h3 className='max-sm:mb-4 !font-medium'>Architecture du logo</h3>
                {/* ADD SUB IF NEEDED */}
              </div>

              <div className='flex flex-col maxW2 gap-10'>
                <h4 className='font-light mx-auto text-left muted font-poppins'>Un design réussi par sa polyvalence, ce logo Amossa a été soigneusement conçu, doté d’une signification profonde et pensé pour représenter la marque ainsi que diverses itérations dans la vie réelle, telles qu’une table, une chaise ou un banc, un support pour produits de consommation, ou encore plus de 10 autres déclinaisons.
                </h4>
                <div className='bg-black= lg:max-w-[300px] aspect-square w-full overflow-clip'>
                  <ImageMedia src={require(`./assets/logoGrid.jpg`)} className={"!mix-blend-screen object-contain aspect-square scale-125"} />
                </div>
              </div>
            </div>
          </div>

          {/*   <div className='bg-black= flex center w-full px-0'>
            <div className=''>
              <ImageMedia src={require(`./assets/grid.PNG`)} />
            </div>
          </div> */}

          <div className='grid grid-cols-2 gap-4 z-[4] bg-black'>
            <ImageMedia src={require(`./assets/bag.jpg`)} />
            <ImageMedia src={require(`./assets/bcard.jpg`)} />
          </div>


          <div className='bg-black flex flex-col center w-full px-0 '>
            <div className='w-full center grid grid-cols-1 lg:grid-cols-2 min-h-[70vh] relative'>
              <ImageMedia src={require(`./assets/folder1.jpg`)} className="w-full" />
              {/* <ImageMedia src={require(`./assets/enveloppe.JPEG`)} className="" /> */}
              <ImageMedia src={require(`./assets/catalogue_.JPEG`)} className="full object-cover" />
            </div>
          </div>

          <MotionContent height={"h-[90vh]"} translateRange={["5%", "-10%"]} className="bg-black ">
            <ImageMedia src={require(`./assets/catalogue_back.JPEG`)} className="full object-center object-cover" />
          </MotionContent>
          <MotionContent height={"h-[90vh]="} translateRange={["5%", "-10%"]} className="bg-black ">
            <ImageMedia src={require(`./assets/XDNB2825.JPEG`)} className="w-full object-center object-contain py-10" />
          </MotionContent>

          <div className='bg-black flex flex-col center w-full px-0 paddingY'>
            <div className='w-full center grid grid-cols-1 min-h-[70vh] relative'>
              <ImageMedia src={require(`./assets/pattern.JPG`)} className="w-1/2 mx-auto my-20 aspect-square max-w-[300px] translate-y-1/2 z-[2] rounded-full" />
              {/* <ImageMedia src={require(`./assets/enveloppe.JPEG`)} className="" /> */}
              <ImageMedia src={require(`./assets/tshirt.JPEG`)} className="full max-h-screen object-contain" />
            </div>
          </div>


          {/*     <ImageMedia src={require(`./grid.PNG`)} className="w-full object-cover z-[1]" />

      <div className='resp relative gap-3 flex flex-col'>
        <div className='grid grid-cols-2 md:grid-cols-2 gap-2 relative  max-h-[40vh] *:full '>
          <ImageMedia src={require(`./_cover.jpg`)} />
          <PrImage src={require(`./_cover.jpg`)} />

        </div>

        <div className='flex relative mt-40'>
          <ImageMedia src={require(`./_cover_.jpg`)} className="h-full object-cover w-full" />
        </div>
      </div> */}

        </>
      )
      }
    </ThisProject >

  )
}

export default Content